import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { PageHero } from "./pages";
import { TaxTransparencyBanner } from "./functional";
import {
  Users, ArrowRight, Copy, Check, Gift, Crown, Zap, Shield,
  Lock, Server, Fingerprint, KeyRound, FileCheck, Eye,
  CreditCard, Smartphone, Globe, Sparkles, Wifi,
  QrCode, ScanLine, ArrowUpRight, Activity, BarChart3,
  TrendingUp, Wallet, Coins, Clock
} from "lucide-react";
import { useT } from "./i18n";

/* ═══════════════════════════ REFERRAL PROGRAM ═══════════════════════════ */
export function ReferralPage() {
  const { t } = useT();
  const [amount, setAmount] = useState(10000);
  const levels = [
    { l: 1, pct: 20, count: 1,   col: "#FFD700" },
    { l: 2, pct: 10, count: 5,   col: "#00F2FF" },
    { l: 3, pct: 5,  count: 25,  col: "#10F4A7" },
    { l: 4, pct: 3,  count: 125, col: "#BC13FE" },
    { l: 5, pct: 2,  count: 625, col: "#F97316" },
    { l: 6, pct: 2,  count: 3125, col: "#FF3D6C" },
    { l: 7, pct: 1,  count: 15625, col: "#7C3AED" },
    { l: 8, pct: 1,  count: 78125, col: "#00B4FF" },
  ];
  const total = levels.reduce((sum, l) => sum + amount * l.pct / 100 * l.count, 0);

  return (
    <main data-testid="page-referral-public">
      <PageHero eyebrow={t("pages3.af290a")} title={<>{t("pages3.3180f8")}<span className="accent">{t("pages3.bc2842")}</span></>}
        lead={t("pages3.d2f281")} />

      <section className="tg-page tg-section-tight">
        <div className="tg-bento">
          {levels.map((lv) => (
            <div key={lv.l} className="tg-card wide" style={{ borderLeft: `4px solid ${lv.col}` }}>
              <div style={{ display: "flex", alignItems: "baseline", gap: 12 }}>
                <div className="tg-stat-num" style={{ color: lv.col, fontSize: 36 }}>L{lv.l}</div>
                <div className="tg-stat-num" style={{ fontSize: 28 }}>{lv.pct}%</div>
              </div>
              <div className="tg-stat-label">{lv.count.toLocaleString("ru-RU")} {t("pages3.e76924")}</div>
            </div>
          ))}
        </div>
      </section>

      {/* CALCULATOR */}
      <section className="tg-page tg-section">
        <div className="tg-card tg-card-glow" style={{ padding: 36 }}>
          <span className="tg-eyebrow">{t("pages3.9b073c")}</span>
          <h2 className="tg-h2" style={{ marginTop: 14 }}>{t("pages3.b7fedd")}</h2>
          <p style={{ color: "var(--tg-text-dim)", marginBottom: 24 }}>{t("pages3.86b0a5")}</p>
          <label style={{ display: "block", fontSize: 13, color: "var(--tg-text-dim)", marginBottom: 8 }}>{t("pages3.0c96ca")}</label>
          <input type="range" min={100} max={50000} step={100} value={amount}
            onChange={(e) => setAmount(+e.target.value)} data-testid="ref-calc-slider"
            style={{ width: "100%", accentColor: "#00F2FF" }} />
          <div style={{ display: "flex", justifyContent: "space-between", fontSize: 13, color: "var(--tg-text-hint)", marginTop: 4 }}>
            <span>€100</span>
            <b style={{ color: "#00F2FF", fontSize: 18 }}>€{amount.toLocaleString("ru-RU")}</b>
            <span>€50,000</span>
          </div>
          <div className="tg-card" style={{ marginTop: 24, textAlign: "center", padding: 32, background: "rgba(255,215,0,0.08)", borderColor: "rgba(255,215,0,0.3)" }}>
            <div className="tg-stat-label">{t("pages3.37fb4c")}</div>
            <div className="tg-stat-num gold" style={{ fontSize: 56 }}>€{Math.round(total).toLocaleString("ru-RU")}</div>
            <div style={{ color: "var(--tg-text-dim)", fontSize: 13, marginTop: 6 }}>
              = {Math.round(total * 10).toLocaleString("ru-RU")} TGC · {t("pages3.cashback-instant")}
            </div>
          </div>
        </div>
      </section>

      {/* MAGIC 44 */}
      <section className="tg-page tg-section">
        <div className="tg-card" style={{ padding: 36, background: "linear-gradient(135deg, rgba(255,215,0,0.1), rgba(188,19,254,0.08))", borderColor: "rgba(255,215,0,0.35)" }}>
          <span className="tg-eyebrow gold"><Crown size={12} /> Magic 44 AirDrop</span>
          <h2 className="tg-h2" style={{ marginTop: 14 }}>{t("pages3.aa2902")}</h2>
          <div className="tg-bento" style={{ marginTop: 24 }}>
            {[
              ["🎁", t("pages3.d0f397"), t("pages3.4a116d")],
              ["💎", t("pages3.609c9b"), t("pages3.9e53e8")],
              ["⚡", "Energy Battery ×3", t("pages3.e494ad")],
              ["💳", "Premium Visa Carbon", t("pages3.d24d1f")],
              ["🗳️", t("pages3.f7da55"), t("pages3.f92ada")],
              ["🎓", "Academy Premium", t("pages3.84d683")],
            ].map(([ic, t, d], i) => (
              <div key={i} className="tg-card">
                <div style={{ fontSize: 28, marginBottom: 10 }}>{ic}</div>
                <div className="text-bold" style={{ fontSize: 15, fontWeight: 700 }}>{t}</div>
                <div style={{ color: "var(--tg-text-dim)", fontSize: 13, marginTop: 6 }}>{d}</div>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="tg-page tg-section" style={{ textAlign: "center" }}>
        <Link to="/app" className="tg-btn gold" data-testid="ref-get-link"><Users size={16} />{t("pages3.faea2d")}</Link>
      </section>
    </main>
  );
}

/* ═══════════════════════════ VIRTUAL VISA CARD ═══════════════════════════ */
export function CardPage() {
  const { t } = useT();
  return (
    <main data-testid="page-card">
      <PageHero eyebrow="Turbo Visa Card" title={<>Virtual Visa — <span className="accent">{t("pages3.8e1d5f")}</span></>}
        lead={t("pages3.dfeb84")} />

      {/* CARD VISUAL */}
      <section className="tg-page tg-section-tight">
        <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 40, alignItems: "center" }} className="tg-card-row">
          <div style={{
            aspectRatio: "1.58/1", borderRadius: 20, padding: 28,
            background: "linear-gradient(135deg, #0D1B4B 0%, #1A3A8F 40%, #0E6B5E 100%)",
            boxShadow: "0 20px 60px rgba(0,0,0,0.5), 0 0 80px rgba(0,242,255,0.15)",
            position: "relative", color: "white", overflow: "hidden",
            border: "1px solid rgba(255,255,255,0.15)",
          }}>
            <div style={{ position: "absolute", top: 20, right: 20, fontWeight: 900, fontSize: 26, color: "#FFD700" }}>VISA</div>
            <div style={{ fontSize: 14, opacity: 0.8, fontWeight: 700, letterSpacing: 2 }}>TURBO GLOBAL</div>
            <div style={{ position: "absolute", bottom: 100, left: 28 }}>
              <div style={{ width: 44, height: 32, borderRadius: 6, background: "linear-gradient(135deg, #FFD700, #C89A00)" }} />
            </div>
            <div style={{ position: "absolute", bottom: 56, left: 28, fontSize: 20, letterSpacing: 3, fontFamily: "monospace" }}>
              5486 ••• ••• 4444
            </div>
            <div style={{ position: "absolute", bottom: 22, left: 28, right: 28, display: "flex", justifyContent: "space-between", fontSize: 11, opacity: 0.9 }}>
              <span>SERGEY E.</span><span>12/29</span>
            </div>
            <Wifi size={20} style={{ position: "absolute", top: 100, right: 20, opacity: 0.9 }} />
          </div>
          <div>
            <span className="tg-eyebrow gold"><Crown size={12} /> Instant Virtual</span>
            <h2 className="tg-h2" style={{ marginTop: 12 }}>{t("pages3.20de6e")}</h2>
            <p className="tg-lead">{t("pages3.109c6e")}</p>
            <ul style={{ padding: 0, listStyle: "none", marginTop: 20 }}>
              {[
                t("pages3.df502c"),
                t("pages3.efbf1f"),
                t("pages3.c60f83"),
                t("pages3.b8e020"),
                t("pages3.07bd78"),
              ].map((x, i) => <li key={i} style={{ padding: "6px 0", color: "var(--tg-text-dim)" }}>{x}</li>)}
            </ul>
          </div>
        </div>
      </section>

      {/* TIERS */}
      <section className="tg-page tg-section">
        <h2 className="tg-h2">{t("pages3.1759d9")}</h2>
        <div className="tg-bento">
          {[
            { t: "Standard Virtual", price: t("pages.6d96fd"), col: "#00F2FF", feats: [t("pages3.810cec"), t("pages3.76d3c7"), t("pages3.3cf221"), t("pages3.a333d4")] },
            { t: "Premium Physical", price: t("pages3.450404"), col: "#FFD700", feats: [t("pages3.f92623"), t("pages3.ed5f02"), "2% cashback · Lounge Pass", t("pages3.ea879c")] },
            { t: "Black Carbon (Magic 44)", price: t("pages3.404050"), col: "#BC13FE", feats: [t("pages3.b30231"), t("pages3.5129ac"), "5% cashback + Energy ×3", t("pages3.6c95f2")] },
          ].map((p, i) => (
            <div key={i} className="tg-card wide" style={{ borderColor: p.col + "55", position: "relative" }}>
              <div style={{ position: "absolute", top: 0, right: 0, padding: "4px 12px", background: p.col, color: "#000", fontSize: 11, fontWeight: 800, borderRadius: "0 20px 0 20px" }}>
                {p.price}
              </div>
              <h3 className="tg-h3" style={{ color: p.col, marginBottom: 16 }}>{p.t}</h3>
              <ul style={{ padding: 0, listStyle: "none" }}>
                {p.feats.map((f, k) => (
                  <li key={k} style={{ padding: "8px 0", fontSize: 14, color: "var(--tg-text-dim)", borderBottom: k < p.feats.length - 1 ? "1px dashed var(--tg-border)" : "none" }}>
                    <Check size={14} color={p.col} style={{ verticalAlign: "middle", marginRight: 8 }} /> {f}
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </section>
    </main>
  );
}

/* ═══════════════════════════ TURBO PAY ═══════════════════════════ */
export function PayPage() {
  const { t } = useT();
  return (
    <main data-testid="page-pay">
      <PageHero eyebrow="Turbo Pay" title={<>{t("pages3.8174d3")}<span className="accent">{t("pages3.5a214f")}</span></>}
        lead={t("pages3.68216e")} />
      <TaxTransparencyBanner />

      {/* HOW IT WORKS */}
      <section className="tg-page tg-section-tight">
        <div className="tg-bento">
          {[
            { n: "1", ic: <ScanLine size={28} />, t: t("pages3.472256"), d: t("pages3.3e8e51") },
            { n: "2", ic: <QrCode size={28} />, t: t("pages3.d28cc9"), d: t("pages3.284faa") },
            { n: "3", ic: <Fingerprint size={28} />, t: "Face ID / Touch ID", d: t("pages3.f84855") },
            { n: "4", ic: <Check size={28} />, t: t("pages3.34e141"), d: t("pages3.6f0687") },
          ].map((s) => (
            <div key={s.n} className="tg-card wide" style={{ textAlign: "center" }}>
              <div className="tg-dropdown-icon" style={{ margin: "0 auto 16px", width: 48, height: 48 }}>{s.ic}</div>
              <div className="tg-eyebrow" style={{ display: "inline-flex" }}>{t("pages3.81c019")} {s.n}</div>
              <h3 className="tg-h3" style={{ marginTop: 12 }}>{s.t}</h3>
              <p style={{ color: "var(--tg-text-dim)", fontSize: 14 }}>{s.d}</p>
            </div>
          ))}
        </div>
      </section>

      {/* CATEGORIES */}
      <section className="tg-page tg-section">
        <h2 className="tg-h2">{t("pages3.9ce36f")}</h2>
        <div className="tg-bento">
          {[
            ["☕", t("pages3.7c753f"), t("pages3.81144a")],
            ["🛒", t("pages3.d0c0ce"), t("pages3.cefaaf")],
            ["⛽", t("pages3.ce191e"), t("pages3.389aa0")],
            ["🎬", t("pages3.e7d368"), t("pages3.e97028")],
            ["💊", t("pages3.faf1d9"), "Europharma, Biosfera, 36,6"],
            ["🚕", t("pages3.63b336"), t("pages3.98e39e")],
            ["🛫", t("pages3.ae617c"), t("pages3.6be239")],
            ["🏨", t("pages3.15ce11"), "Booking partners, Marriott QR"],
          ].map(([ic, t, d], i) => (
            <div key={i} className="tg-card">
              <div style={{ fontSize: 32, marginBottom: 10 }}>{ic}</div>
              <div className="text-bold" style={{ fontSize: 14, fontWeight: 700 }}>{t}</div>
              <div style={{ color: "var(--tg-text-hint)", fontSize: 12, marginTop: 4 }}>{d}</div>
            </div>
          ))}
        </div>
      </section>

      {/* COMPARISON */}
      <section className="tg-page tg-section">
        <h2 className="tg-h2">{t("pages3.104ff3")}</h2>
        <div className="tg-card">
          <table className="tg-table">
            <thead><tr><th></th><th>Turbo Pay</th><th>Visa / MC</th><th>Apple Pay</th></tr></thead>
            <tbody>
              <tr><td>{t("pages3.04b57d")}</td><td style={{ color: "#10F4A7" }}><b>0.1-0.5%</b></td><td>2.5%</td><td>2.5%</td></tr>
              <tr><td>{t("pages3.d869a5")}</td><td style={{ color: "#10F4A7" }}><b>{t("pages3.b77909")}</b></td><td>1%</td><td>0%</td></tr>
              <tr><td>{t("pages3.0a578c")}</td><td><b>{t("pages3.fcdd13")}</b></td><td>{t("pages3.c86ecb")}</td><td>{t("pages3.0dd103")}</td></tr>
              <tr><td>{t("pages3.39c06e")}</td><td style={{ color: "#10F4A7" }}><b>0%</b></td><td>3%</td><td>3%</td></tr>
              <tr><td>{t("pages3.c7d116")}</td><td style={{ color: "#10F4A7" }}><b>✓</b></td><td>✗</td><td>✗</td></tr>
            </tbody>
          </table>
        </div>
      </section>
    </main>
  );
}

/* ═══════════════════════════ SECURITY ═══════════════════════════ */
export function SecurityPage() {
  const { t } = useT();
  return (
    <main data-testid="page-security">
      <PageHero eyebrow={t("header.company.security.title")} title={<>{t("pages3.d2cde2")}<span className="accent">{t("pages3.66c2e4")}</span></>}
        lead={t("pages3.e2ecb0")} />

      <section className="tg-page tg-section-tight">
        <div className="tg-bento">
          {[
            { ic: <Server size={24} />, t: "Cold Storage", d: t("pages3.c1095f") },
            { ic: <Shield size={24} />, t: "Smart-Contract Audit", d: t("pages3.29c426") },
            { ic: <KeyRound size={24} />, t: t("pages3.d26a29"), d: t("pages3.099e48") },
            { ic: <Fingerprint size={24} />, t: "Biometric 2FA", d: t("pages3.7394bc") },
            { ic: <Eye size={24} />, t: "On-Chain Transparency", d: t("pages3.32e279") },
            { ic: <Lock size={24} />, t: "Resilience Fund", d: t("pages3.c57ecd") },
          ].map((c, i) => (
            <div key={i} className="tg-card wide">
              <div className="tg-dropdown-icon" style={{ marginBottom: 14 }}>{c.ic}</div>
              <h3 className="tg-h3">{c.t}</h3>
              <p style={{ color: "var(--tg-text-dim)", fontSize: 14 }}>{c.d}</p>
            </div>
          ))}
        </div>
      </section>

      <section className="tg-page tg-section">
        <div className="tg-card tg-card-glow" style={{ padding: 36 }}>
          <h2 className="tg-h2">{t("pages3.4b8fdf")}</h2>
          <p style={{ color: "var(--tg-text-dim)", marginBottom: 20 }}>{t("pages3.a42678")}</p>
          {[
            t("pages3.dacec6"),
            t("pages3.b0b9ee"),
            t("pages3.1d8e0e"),
            t("pages3.672013"),
            t("pages3.d05b3c"),
            t("pages3.4a1c06"),
            t("pages3.4d8ee2"),
          ].map((item, i) => (
            <div key={i} style={{ padding: "12px 0", borderBottom: i < 6 ? "1px dashed var(--tg-border)" : "none", fontSize: 15 }}>
              <Check size={16} color="#10F4A7" style={{ verticalAlign: "middle", marginRight: 12 }} /> {item}
            </div>
          ))}
        </div>
      </section>
    </main>
  );
}

/* ═══════════════════════════ LIVE STATS DASHBOARD ═══════════════════════════ */
export function StatsPage() {
  const { t } = useT();
  const [tick, setTick] = useState(0);
  useEffect(() => {
    const t = setInterval(() => setTick((v) => v + 1), 2000);
    return () => clearInterval(t);
  }, []);
  const rand = (base, variance) => base + Math.floor(Math.random() * variance);

  return (
    <main data-testid="page-stats">
      <PageHero eyebrow="Live Stats" title={<>{t("header.ecosystem.stats.desc")}<span className="accent">{t("pages3.53de27")}</span></>}
        lead={t("pages3.4a8d7a")} />

      {/* BIG NUMBERS */}
      <section className="tg-page tg-section-tight">
        <div className="tg-bento">
          {[
            { num: rand(14328 + tick, 3).toLocaleString("ru-RU"), l: t("pages3.115fa6"), col: "#00F2FF", icon: <Wallet size={18} /> },
            { num: "$" + rand(4_200_000 + tick * 100, 500).toLocaleString("ru-RU"), l: t("pages3.b50b33"), col: "#10F4A7", icon: <TrendingUp size={18} /> },
            { num: rand(640 + Math.floor(tick / 20), 2).toLocaleString("ru-RU"), l: t("pages3.001396"), col: "#FFD700", icon: <BarChart3 size={18} /> },
            { num: "$" + rand(12_400_000 + tick * 1000, 5000).toLocaleString("ru-RU"), l: t("pages3.f14bea"), col: "#BC13FE", icon: <Activity size={18} /> },
          ].map((c, i) => (
            <div key={i} className="tg-card wide" style={{ position: "relative" }}>
              <div style={{ position: "absolute", top: 16, right: 16, display: "flex", alignItems: "center", gap: 4 }}>
                <div style={{ width: 6, height: 6, borderRadius: 3, background: "#10F4A7", animation: "pulse 1.2s infinite" }} />
                <span className="tg-stat-label" style={{ margin: 0, fontSize: 10 }}>LIVE</span>
              </div>
              <div style={{ color: c.col, marginBottom: 10 }}>{c.icon}</div>
              <div className="tg-stat-num" style={{ color: c.col, fontSize: 32, fontFeatureSettings: '"tnum"' }}>{c.num}</div>
              <div className="tg-stat-label">{c.l}</div>
            </div>
          ))}
        </div>
      </section>

      {/* LIVE TRANSACTIONS */}
      <section className="tg-page tg-section">
        <h2 className="tg-h2">{t("pages3.d4d131")}</h2>
        <div className="tg-card" style={{ padding: 0, overflow: "hidden" }}>
          <div style={{ padding: "16px 20px", borderBottom: "1px solid var(--tg-border)", display: "flex", gap: 20, fontSize: 11, textTransform: "uppercase", letterSpacing: 1, color: "var(--tg-blue)", fontWeight: 700 }}>
            <div style={{ flex: 1 }}>{t("pages3.3e729b")}</div>
            <div style={{ flex: 2 }}>{t("pages3.345805")}</div>
            <div style={{ flex: 2, textAlign: "right" }}>{t("pages3.cf59eb")}</div>
            <div style={{ flex: 1, textAlign: "right" }}>Hash</div>
          </div>
          {[
            [t("pages3.37a33d"), "Staking (Silver €1,000)", "+TGC ≈ €100", "0xa8b...4f91"],
            [t("pages3.39178b"), t("pages3.c418c6"), "-45 TGC",    "0x3c4...9b22"],
            [t("pages3.851693"), "Referral L3 · bonus",       "+12 TGC",    "0x7d8...1e03"],
            [t("pages3.6bad09"),  "P2P: USDT → TGC",           "+5,000 TGC", "0xb1a...7c88"],
            [t("pages3.6bad09"),  "Pension accrual (daily)",   "+3.28 TGC",  "0x9fe...2d44"],
            [t("pages3.c6cf1c"),  "Charity donation 1%",       "-0.45 TGC",  "0x4aa...88f2"],
            [t("pages3.c6cf1c"),  "Magic 44 bonus (#44)",      "+5,000 TGC", "0xcc1...dead"],
            [t("pages3.6b79c5"),  "Visa: Uber ride",           "-€8.50",      "0x2f3...aa77"],
          ].map((row, i) => (
            <div key={i} style={{ padding: "14px 20px", borderBottom: i < 7 ? "1px dashed var(--tg-border)" : "none", display: "flex", gap: 20, fontSize: 13, alignItems: "center" }}>
              <div style={{ flex: 1, color: "var(--tg-text-hint)" }}><Clock size={12} style={{ verticalAlign: "middle", marginRight: 4 }} />{row[0]}</div>
              <div style={{ flex: 2 }}>{row[1]}</div>
              <div style={{ flex: 2, textAlign: "right", color: row[2].startsWith("+") ? "#10F4A7" : "#FF3D6C", fontWeight: 700, fontFeatureSettings: '"tnum"' }}>{row[2]}</div>
              <div style={{ flex: 1, textAlign: "right", color: "var(--tg-blue)", fontFamily: "monospace", fontSize: 12 }}>{row[3]} <ArrowUpRight size={10} style={{ verticalAlign: "middle" }} /></div>
            </div>
          ))}
        </div>
      </section>

      {/* TOKENOMICS LIVE */}
      <section className="tg-page tg-section-tight">
        <div className="tg-bento">
          {[
            { l: t("pages3.dc0585"), v: rand(98_420_000 + tick * 1000, 100).toLocaleString("ru-RU") + " TGC" },
            { l: t("pages3.c3853d"),   v: rand(2_840, 50).toLocaleString("ru-RU") + " TGC 🔥" },
            { l: t("pages3.4ff0ba"),     v: rand(3_284, 10).toLocaleString("ru-RU") },
            { l: "Charity Fund",         v: "$" + rand(42_810, 50).toLocaleString("ru-RU") },
          ].map((c, i) => (
            <div key={i} className="tg-card">
              <div className="tg-stat-label">{c.l}</div>
              <div className="text-bold" style={{ fontSize: 18, marginTop: 6, fontFeatureSettings: '"tnum"' }}>{c.v}</div>
            </div>
          ))}
        </div>
      </section>
    </main>
  );
}
